import { fetcher, ResponseWrapper } from '@tlx/astro-shared';
import { APIUrls } from '@Util/urls';
import useSWR from 'swr';

const neededPilotFeatures = [
    'SalaryRedesignMVP',
    'CreateSalaryRedesignMVP',
    'SalaryOverview',
    'NewEmployeeOverview',
    'EndEmploymentsBatchAction',
    'SalaryApprovalAction',
    'Attestation',
] as const;

export type PagesPilotFeatureFlags = {
    [K in (typeof neededPilotFeatures)[number]]: boolean;
};

const getUrl = () => {
    const baseUrl = APIUrls.PILOT_FEATURE;
    const searchParams = new URLSearchParams();
    searchParams.set('pilotFeatures', neededPilotFeatures.join(','));
    return baseUrl + '?' + searchParams.toString();
};

export const usePagesPilotFeatureFlags = () => {
    return useSWR<ResponseWrapper<PagesPilotFeatureFlags>>(getUrl, fetcher, {
        revalidateOnFocus: false,
    });
};
